const HAS_DISCOUNT_PROP = "_has_bundle_discount";

async function patchLineProps(lineKey, quantity, existingProps = {}, hasDisc) {
  const props = { ...existingProps, [HAS_DISCOUNT_PROP]: hasDisc ? true : false }; 
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Has-Disc-Patch": "1" },
    credentials: "same-origin",
    body: JSON.stringify({ id: lineKey, quantity, properties: props })
  }).catch(console.error);
}



function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items')?.dataset?.id,
      selector: '.js-contents',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section'
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer')?.dataset?.id,
      selector: '.js-contents',
    },
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '#CartDrawer',
    }
  ];
}


async function removeByKeys(lineKeys = []) {
  const updates = {};
  for (const k of lineKeys) updates[k] = 0;

  const res = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Has-Disc-Patch": "1" },
    credentials: "same-origin",
    body: JSON.stringify({ 
      updates: updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }),
  }).then(res => res.json());

  if (!res) throw new Error("Failed to update cart");

  getSectionsToRender().forEach((section => {
    const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
    if(elementToReplace){
      elementToReplace.innerHTML = getSectionInnerHTML(res.sections[section.section], section.selector);
    }
  }));

  return res;
}

document.addEventListener("DOMContentLoaded", function() {
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0].url || '';
      if (/\/cart\/(add|change|update)(\?|$)/.test(url)) {
        
        const json = await res.clone().json().catch(() => null);
        if (!json?.items?.length) return res;

        const tasks = [];

        for (const item of json.items) {
          const allocs = item.line_level_discount_allocations || item.discount_allocations || [];
          const hasDisc = allocs.length > 0;
          const flagSet = Boolean(item.properties?.[HAS_DISCOUNT_PROP]);

          if (hasDisc && !flagSet) {
            tasks.push(patchLineProps(item.key, item.quantity, item.properties || {}, true));
          } else if (!hasDisc && flagSet) {
            tasks.push(patchLineProps(item.key, item.quantity, item.properties || {}, false));
          }
        }

        await Promise.allSettled(tasks); 

        let totalSum = json.items
        .filter((i) => i.properties._free_gift)
        .reduce((sum, item) => sum + item.price, 0); 


      const totalPriceWithoutFree = ((json.total_price/100)-((totalSum/100) ?? 0));

        if(promo_product.threshold_amount>totalPriceWithoutFree){
          let free_gift_items = json.items.filter((i) => i.properties._free_gift);
          let free_gift_items_keys = free_gift_items.map((i) => i.key);
          if(free_gift_items_keys.length>0){
            setTimeout(async () => {
              await removeByKeys(free_gift_items_keys);
            }, 100)
          }
        }

        return res;


      }
    } catch (e) {
      console.error(e)
    }
    return res;
  };
});
